import styled from '@emotion/styled';
import { FileReference } from '@kaizenplatform/belfast-entity';
import { Typography } from '@material-ui/core';
import { createElement, FC } from 'react';
import { FormattedMessage } from 'react-intl';

import FileList, { FileListItem } from '../FileList';

interface Props {
  files: FileReference[];
}

const FileListContainer: FC<Props> = ({ files }) => {
  const children =
    files.length >= 1 ? (
      <Container>
        <FileList>
          {files.map((file) => (
            <FileListItem file={file} key={file.id} />
          ))}
        </FileList>
      </Container>
    ) : (
      <Typography>
        <FormattedMessage id="creative_brief_detail.field.files.empty" />
      </Typography>
    );

  return children;
};

const Container = styled('div')({});

export default FileListContainer;
